import { useMutation } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import { REJECT_FACEBOOK_IMPORT_REQUEST_MUTATION } from './rejectFacebookImportRequest.mutation';
import {
  RejectFacebookImportRequestMutation,
  RejectFacebookImportRequestMutationVariables
} from './__generated__/RejectFacebookImportRequestMutation';

interface MutationProps {
  onCompleted: () => void;
  onError: (errors: string[]) => void;
}

export function useRejectFacebookImportRequest({
  onCompleted,
  onError
}: MutationProps): [(variables: RejectFacebookImportRequestMutationVariables) => void, { loading: boolean }] {
  const [rejectFacebookImportRequest, { loading }] = useMutation<
    RejectFacebookImportRequestMutation,
    RejectFacebookImportRequestMutationVariables
  >(REJECT_FACEBOOK_IMPORT_REQUEST_MUTATION, {
    client: kmsClient,
    onCompleted: (data) => {
      if (data.rejectFacebookImportRequest?.errors?.length) {
        onError(data.rejectFacebookImportRequest.errors);
      } else {
        onCompleted();
      }
    },
    onError: (error) => onError([error.message])
  });

  return [
    (variables: RejectFacebookImportRequestMutationVariables) => {
      rejectFacebookImportRequest({ variables });
    },
    { loading }
  ];
}
